// Declare state
export type State = Record<string, never>; // {};

// Create initial state
export const state = {} as State;
